import React from "react";
import styled from "styled-components";
import Download from "sushiweb/Icons/all/Download";
import variables from "../../../constants/assets/variables";

const DownloadBar = ({ downloadLink = "#", title, handleDownload }) => {
  return (
    <DownloadBarContainer
      //   target="_blank"
      rel="noopener noreferrer"
      onClick={handleDownload}
      href={downloadLink}
      download={downloadLink !== "#" ? true : false}
    >
      <Download color={variables.black} />
      <span>{title || "Download"}</span>
    </DownloadBarContainer>
  );
};

const DownloadBarContainer = styled.a`
  border: 1px solid ${variables.primaryColor};
  text-decoration: none;
  padding: 20px;
  border-radius: 8px;
  max-width: 40%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    margin-bottom: 4px;
    margin-right: 10px;
  }
  span {
    color: ${variables.black};
  }
  &:hover {
    background: ${variables.grey200};
  }
`;

export default DownloadBar;
